import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m?.[1];
    (async () => {
      if (!session_id) {
        nav("/login", { replace: true });
        return;
      }
      try {
        const user = await exchangeGoogleSession(session_id);
        // strip hash and go
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [exchangeGoogleSession, nav]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-sm text-inkSoft">
        <Loader2 className="animate-spin" size={18} /> Signing you in…
      </div>
    </div>
  );
}
